import React from "react";

const Notfound = () => {
  return <div>PAGE NOT FOUND</div>;
};

export default Notfound;
